import { AccountBalanceWallet } from "@mui/icons-material"
import {
  AppBar,
  Container,
  Stack,
  Button,
  Typography,
  useScrollTrigger,
  Toolbar,
  Tooltip,
  useMediaQuery,
  Theme,
} from "@mui/material"
import { useActiveAddress, useConnection } from "arweave-wallet-kit"
import { Link, useLocation } from "react-router-dom"

import { Logo } from "./Logo"
import { SearchBar } from "./SearchBar"
import { ThemeMode } from "./ThemeMode"
import { NumberFont } from "./fonts"
import { truncateId } from "@/utils/data-utils"

const Header = () => {
  const elevated = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: typeof window !== "undefined" ? window : undefined,
  })

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"))

  const activeAddress = useActiveAddress()
  const { connect, disconnect } = useConnection()

  const location = useLocation()
  const userPageActive = location.pathname.includes(`/entity/${activeAddress}`)

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "background.default",

        borderBottom: "1px solid rgba(105, 105, 105, 0.25)",
        ...(elevated ? { borderColor: "var(--mui-palette-divider)" } : {}),
      }}
    >
      <Container
        maxWidth="xl"
        component={Toolbar}
        disableGutters
        sx={{
          display: "grid",
          gap: 1,
          gridTemplateColumns: {
            xs: "1fr auto auto",
            md: "1fr auto 1fr",
          },
          alignItems: "center",
          justifyItems: "center",
        }}
      >
        <Button
          component={Link}
          to="/"
          size="large"
          sx={{
            marginX: 0.5,
            textTransform: "uppercase",
            justifySelf: "start",
            minWidth: "unset",
            paddingX: { xs: 1, sm: 2 },
          }}
        >
          <Stack direction="row" gap={1} alignItems="center">
            <Logo color="var(--mui-palette-text-primary)" />
            <Typography
              color="text.primary"
              variant="body2"
              fontFamily={NumberFont}
              sx={{ display: { xs: "none", sm: "inline" } }}
            >
              Dexi
            </Typography>
          </Stack>
        </Button>

        <SearchBar />

        <Stack
          direction="row"
          gap={1}
          alignItems="center"
          justifyContent="flex-end"
          sx={{ width: { xs: "auto", md: "100%" } }}
        >
          {activeAddress && (
            <Button
              variant="outlined"
              color={!userPageActive ? "secondary" : "accent"}
              component={Link}
              to={`/entity/${activeAddress}`}
              startIcon={!isDesktop ? null : <AccountBalanceWallet />}
              sx={{
                minWidth: "unset",
                textTransform: "none",
                paddingX: { xs: 1, sm: 2 },
              }}
            >
              {!isDesktop ? <AccountBalanceWallet /> : "My Portfolio"}
            </Button>
          )}

          <Tooltip title={!activeAddress ? "" : "Disconnect Wallet"}>
            <Button
              onClick={!activeAddress ? connect : disconnect}
              variant="outlined"
              color={activeAddress ? "secondary" : "accent"}
              sx={{
                textTransform: "none",
                background: activeAddress
                  ? ""
                  : "rgba(var(--mui-palette-success-mainChannel) / 0.1)",
                paddingX: { xs: 1, sm: 2 },
              }}
            >
              {activeAddress
                ? truncateId(activeAddress)
                : isMobile
                  ? "Connect Wallet"
                  : "Connect Wallet to use Agents"}
            </Button>
          </Tooltip>
          <ThemeMode />
        </Stack>
      </Container>
    </AppBar>
  )
}

export default Header
